import React from "react"

import {addClass, removeClass, clearFormError, getJSON_and_status} from '../components/GlobalFunctions';

import SingleInput from '../components/SingleInput';

import SHA256 from "crypto-js/sha256";

class Step2 extends React.Component {

	constructor(props) {
		super(props);
		this.onInputFocus = this.onInputFocus.bind(this);
		this.handlePassChange = this.handlePassChange.bind(this);
		this.handlePass2Change = this.handlePass2Change.bind(this);
		this.checkForm = this.checkForm.bind(this);
		this.state = {
			visible: false,
			error: '',
			pass1: '',
			pass2: '',
			hasHash: props.hasHash,

			recoveryError: '',
			recoveryDisabled: false,
		};
	}

	handlePassChange(e) { this.setState({ pass1: e.target.value }) }

	handlePass2Change(e) { this.setState({ pass2: e.target.value }) }

	onInputFocus(s){ addClass(s.target.parentNode,"input--filled"),this.setState({ recoveryError: '' }) }

	onInputBlur(s){ ""===s.target.value.trim()&&removeClass(s.target.parentNode,"input--filled") }
	
	checkForm(e) {
		e.preventDefault();
		var self = this;

		self.setState({ recoveryDisabled: true, recoveryError: '' });

		getJSON_and_status('POST', '/api/password/recovery', 'hash='+self.props.hash+'&pass1='+SHA256(self.state.pass1)+'&pass2='+SHA256(self.state.pass2), function(data){

			self.props.nextStep.call(this);	

		}, function(error, status){var statusArray=JSON.parse(error);

			if(status === 400) {
				if(statusArray.fields && statusArray.fields !== 'undefined') {
					var forgotErrorFields = '';
					if(statusArray.fields.length>0) {
						for (var i = 0; i < statusArray.fields.length; i++) {
							forgotErrorFields += statusArray.fields[i]+'\n';
						}
					}
					self.setState({ error: forgotErrorFields });
				} else if(statusArray.message && statusArray.message !== 'undefined') {
					self.setState({ error: statusArray.message });
				}
				self.props.setData(self);
				self.props.prevStep.call(self);
			} else {
				if(statusArray.fields && statusArray.fields !== 'undefined') {
					var forgotErrorFields = '';
					if(statusArray.fields.length>0) {
						for (var i = 0; i < statusArray.fields.length; i++) {
							forgotErrorFields += '<p>'+statusArray.fields[i]+'</p>';
						}
					}
					self.setState({ recoveryError: forgotErrorFields });
				} else if(statusArray.message && statusArray.message !== 'undefined') {
					self.setState({ recoveryError: '<p>'+statusArray.message+'</p>' });
				}
				self.setState({ recoveryDisabled: false });
			}
		});
	}

	componentWillMount() {

		var self = this;
		if(self.state.hasHash) {
			if(self.state.hasHash!=='') {
				self.setState({ visible: true });
			} else {
				self.setState({ error: 'Enter your verification code from email!' });
				self.props.setData(self);
				self.props.prevStep.call(this);
			}
		} else {
			self.setState({ visible: true });
		}

	}

	componentDidMount() {
		for(var fieldList=document.querySelectorAll(".input__field"),i=0;i<fieldList.length;i++)""!==fieldList[i].value.trim()&&addClass(fieldList[i].parentNode,"input--filled");
	}

	render() {
		if(this.state && this.state.visible) {
			return (
				<form id="forgotForm" className="form" onSubmit={this.checkForm}>
					<div className="form-info">{this.props.message}</div>
					<div id="forgotError" className="form-error" dangerouslySetInnerHTML={{ __html: this.state.recoveryError }}></div>

					<div className="form-row" title="Your new password">
						<input
							className="form-input input__field"
							name='forgotNewPassword'
							type='password'
							value={this.state.pass1}
							required={true}
							onChange={this.handlePassChange}
							onFocus={this.onInputFocus}
							onBlur={this.onInputBlur}
							placeholder='Enter your new password'
							pattern=".{5,}"
							title="Minimum 5 characters required" />
						<svg viewBox="0 0 20 20"><path fill="#D2D2D2" d='M14.8,15.1c0,0.4-0.4,0.8-0.8,0.8H6c-0.4,0-0.8-0.4-0.8-0.8v-4.8c0-0.4,0.4-0.8,0.8-0.8h0.3V7.9c0-2.1,1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8v1.6H14c0.4,0,0.8,0.4,0.8,0.8V15.1z M12.1,9.5V7.9c0-1.2-1-2.1-2.1-2.1s-2.1,1-2.1,2.1v1.6H12.1z' /></svg>
					</div>

					<div className="form-row" title="Repeat your new password">
						<input
							className="form-input input__field"
							name='forgotNewPassword'
							type='password'
							value={this.state.pass2}
							required={true}
							onChange={this.handlePass2Change}
							onFocus={this.onInputFocus}
							onBlur={this.onInputBlur}
							placeholder='Retype your new password'
							pattern=".{5,}"
							title="Minimum 5 characters required" />
						<svg viewBox="0 0 20 20"><path fill="#D2D2D2" d='M14.8,15.1c0,0.4-0.4,0.8-0.8,0.8H6c-0.4,0-0.8-0.4-0.8-0.8v-4.8c0-0.4,0.4-0.8,0.8-0.8h0.3V7.9c0-2.1,1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8v1.6H14c0.4,0,0.8,0.4,0.8,0.8V15.1z M12.1,9.5V7.9c0-1.2-1-2.1-2.1-2.1s-2.1,1-2.1,2.1v1.6H12.1z' /></svg>
					</div>

					<div className="form-row form-row-submit">
						<input id="forgotSubmit" className="form-submit" type="submit" value="Send" disabled={this.state.recoveryDisabled} />
					</div>
				</form>
			);
		} else {
			return null;
		}

	}
}

export default Step2;


// WEBPACK FOOTER //
// ./src/recovery/Step2.js